const LOGIN_TOKEN_NAME = 'login_token'

function setLoginToken(value) {
  localStorage.setItem(LOGIN_TOKEN_NAME, value)
}

function removeLoginToken() {
  localStorage.removeItem(LOGIN_TOKEN_NAME)
}

function getLoginToken() {
  return localStorage.getItem(LOGIN_TOKEN_NAME)
}

function clear() {
  localStorage.clear()
}

export {
  setLoginToken,
  removeLoginToken,
  getLoginToken,
  clear,
}
